// Importujemy wspólne komponenty i moduły z main.js
import { sharedComponents, sharedElementPlusComponents } from '../utils/vue.js';
import { useCommonLogic } from '../utils/commonVue.js'; // Importujemy logikę
export default {
    components: {
        ...sharedComponents,
        ...sharedElementPlusComponents
    },
    setup () {
        const commonLogic = useCommonLogic();
        return {
            ...commonLogic
        };
    }
};
